
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { getImageURL } from '@/utils/getters';
import TagPreview from '@/components/shared/TagPreview.vue';

const namespace = 'orders';

@Component<OrderMenuCard>({
	components: {
		TagPreview
	}
})
export default class OrderMenuCard extends Vue {
	@Action('setSelectedItem', { namespace }) private setSelectedItem!: (payload: { selectedItem: MenuItem; sectionSlug?: string }) => void;
	@Prop({ type: Object, required: true }) private item!: MenuItem;
	@Prop({ type: Boolean, required: true }) private doesMenuHaveImages!: boolean;
	@Prop({ type: String, default: undefined }) private sectionSlug!: string | undefined;

	private get mappedTags(): MenuItemTag[] {
		return [...(this.item.tags || [])].sort((a, b) => +new Date(a.created_at) - +new Date(b.created_at));
	}

	private get imageURL(): string {
		return getImageURL(this.item.image);
	}

	/**
	 * Set the selected item if it is not sold out
	 *
	 * @return {void}
	 */
	private itemSelected(): void {
		if (this.item.sold_out || this.item.unavailable) {
			return;
		}
		this.setSelectedItem({ selectedItem: this.item, sectionSlug: this.sectionSlug });
	}
}
